<template>
  <sliding-pagination
    :current="page"
    :total="length"
    @page-change="pageChangeHandler"
    v-if="length !== 0"
  >
  </sliding-pagination>
</template>

<script>
import SlidingPagination from 'vue-sliding-pagination'
import 'vue-sliding-pagination/dist/style/vue-sliding-pagination.css'
export default {
  components: {
    SlidingPagination
  },
  props: ['page', 'length'],
  methods: {
    pageChangeHandler: function (page) {
      this.$emit('changePage', page)
    }
  }
}
</script>

<style>
.c-sliding-pagination {
  display: flex;
  justify-content: center;
}

.c-sliding-pagination__list-element {
  padding: 3px 12px;
  margin: 0 5px;
  background-color: transparent;
  border: 1px solid #ffa500;
  color: #ffa500;
}

.c-sliding-pagination__list-element--active {
  background-color: #ffa500;
}

.c-sliding-pagination__list-element--active a {
  color: #fff;
}

.c-sliding-pagination__list-element:hover {
  background-color: #ffa500;
}

.c-sliding-pagination__page:hover {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/News/Pagination.vue